import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import { fetchApiData } from "../../../../redux/reducers/commonApiSlice";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import { applicableSubscriptions } from "../../../../data/ApiEndpoints";
import {
  convertStraight,
  convertThenFormat,
  fixedTwo,
  formatDateTimezon,
} from "../../../common-data/Converts";
import SearchNButtons from "../../../common-components/SearchNButtons";
import PayoutsTable from "../../../components-bootstrap/PayoutsTable";
import PTTransferDetails from "./PTTransferDetails";
import CommonStatCard from "../../../pt/pt-flow-new/CommonStatCard";
import PTSaleDetails from "./PTSaleDetails";
import ApplicableSubsMobile from "./ApplicableSubsMobile";
import PartialDetailsMobile from "../PartialDetailsMobile";

const getCardLabel = (key) => {
  switch (key) {
    case "total_completed_ssn_incentive":
      return "total completed session incentive";
    case "total_completed_ssn":
      return "total completed session";
    default:
      return key.replace(/_/g, " ");
  }
};

const getCardValue = (key, value) => {
  switch (key) {
    case "total_completed_ssn_incentive":
      return `₹${convertThenFormat(value || 0)}`;
    default:
      return convertThenFormat(value || 0);
  }
};

const ApplicableSubscriptions = ({
  userInfoData,
  rowData,
  onCloseModal,
  prevFilters,
}) => {
  const dispatch = useDispatch();
  const { loading, data, error } = useSelector((state) => state.common);

  const iniAllDatas = {
    pagination: [],
    allData: [],
    allStatsData: {},
  };
  const [allDatas, setAllDatas] = useState(iniAllDatas);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    month: prevFilters.month || "",
    year: prevFilters.year || "",
    trainer_id: rowData?.trainer_id || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    payment_details: [],
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function getDetails(filters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: applicableSubscriptions,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (filters.trainer_id) {
      getDetails(filters);
    }
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (data?.status && data?.data?.length > 0 && !loading && !error) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: data.data,
        pagination: data?.pagination?.length > 0 ? data.pagination : [],
        allStatsData: data.stats || {},
      }));
    } else {
      setAllDatas(iniAllDatas);
    }
  }, [data, loading, error]);

  const tbColumn = [
    // {
    //   dataField: "user_id",
    //   text: "member detail",
    //   formatter: (cell, row) => (
    //     <span className="tb-data minWidth100">
    //       {row?.user_name || "NA"}
    //       <br />
    //       <small className="lowercase">
    //         {row?.user_mobile || ""}
    //         <br />
    //         {row?.user_email || ""}
    //       </small>
    //     </span>
    //   ),
    // },
    {
      dataField: "incentive_percentage",
      text: "incentive percentage",
      formatter: (cell, row) => (
        <span className="tb-data">{row?.incentive_percentage || 0} %</span>
      ),
    },
    {
      dataField: "purchase_month_sale",
      text: "Total PT Sale",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth90 link"
          onClick={() =>
            setModValues((prevs) => ({
              ...prevs,
              isModOpen: true,
              cardName: "total_PT_sale",
              rowData: row,
            }))
          }
        >
          ₹{convertThenFormat(row?.purchase_month_sale || 0)}
          <br />
          <small className="underline gray">
            {row?.purchase_month || "-"}/{row?.purchase_year || "-"}
          </small>
        </span>
      ),
    },
    {
      dataField: "amount_paid_inpurchase_month",
      text: "Amount paid during purchase",
      formatter: (cell, row) => (
        <span
          className={`tb-data minWidth90 ${row?.is_partial ? "link" : ""}`}
          onClick={() =>
            setModValues((prevs) => ({
              ...prevs,
              isModOpen: true,
              cardName: "partial_details",
              partialDetails: row?.payment_details || [],
            }))
          }
        >
          ₹{convertThenFormat(row?.amount_paid_inpurchase_month || 0)}
        </span>
      ),
    },
    {
      dataField: "paid_amount_byincentive_percentage",
      text: "paid Amount incentive",
      formatter: (cell, row) => (
        <span className="tb-data">
          ₹{convertThenFormat(row?.paid_amount_byincentive_percentage || 0)}
        </span>
      ),
    },
    {
      dataField: "per_ssn_cost",
      text: "per session cost",
      formatter: (cell, row) => (
        <span className="tb-data">₹{fixedTwo(row?.per_ssn_cost || 0)}</span>
      ),
    },
    {
      dataField: "completed_ssn_incentive",
      text: "completed session incentive",
      formatter: (cell, row) => (
        <span className="tb-data">
          ₹{fixedTwo(row?.completed_ssn_incentive || 0)}
        </span>
      ),
    },
    {
      dataField: "completed_ssn_month",
      text: "session completion month",
      formatter: (cell, row) => (
        <span className="tb-data">
          {row?.completed_ssn_month || "-"}/{row?.completed_ssn_year || "-"}
        </span>
      ),
    },
    {
      dataField: "total_plan_session",
      text: "session status",
      formatter: (cell, row) => (
        <span
          className="tb-data link"
          onClick={() =>
            setModValues((prevs) => ({
              ...prevs,
              isModOpen: true,
              cardName: "PT_sessions_details",
              rowData: row,
            }))
          }
        >
          {row?.total_completed_ssn || 0}/{row?.total_plan_session || 0}
        </span>
      ),
    },
    {
      dataField: "subs_date_added",
      text: "subscription duration",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth180">
            <small className="underline gray">
              {row?.subs_date_added
                ? formatDateTimezon(row.subs_date_added)
                : "-"}
            </small>
            <br />
            <small>
              {row?.subs_start_date
                ? formatDateTimezon(row.subs_start_date)
                : "-"}
              /
              {row?.subs_expire_date
                ? formatDateTimezon(row.subs_expire_date)
                : "-"}
            </small>
          </span>
        );
      },
    },
    // {
    //   dataField: "subscription_id",
    //   text: "plan name",
    //   formatter: (cell, row) => (
    //     <span className="tb-data">
    //       {row?.plan_name
    //         ? row.plan_name === "Personal Training"
    //           ? "PT"
    //           : row.plan_name
    //         : "NA"}
    //     </span>
    //   ),
    // },
    // {
    //   dataField: "gym_name",
    //   text: "Gym Name",
    //   formatter: (cell, row) => (
    //     <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
    //   ),
    // },
    // {
    //   dataField: "trainer_id",
    //   text: "trainer detail",
    //   formatter: (cell, row) => (
    //     <span className="tb-data minWidth100">
    //       {row?.trainer_name || "NA"}
    //       <br />
    //       <small className="lowercase">
    //         {row?.trainer_mobile || ""}
    //         <br />
    //         {row?.trainer_email || ""}
    //       </small>
    //     </span>
    //   ),
    // },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={() => setModValues(iniModvalues)}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardName === "partial_details" ? "mod-width-50p" : ""
          }`}
        >
          {modValues.cardName !== "total_PT_sale" && (
            <ModalHeadAndClose
              title={modValues.cardName?.replace(/_/g, " ")}
              onClose={() => setModValues(iniModvalues)}
            />
          )}

          {modValues.cardName === "partial_details" ? (
            <>
              <div className="fullWidthFlexCenter separatedTable hideMobile">
                <PayoutsTable
                  dataValues={modValues.partialDetails}
                  columnsValues={pmInfoColumns}
                />
              </div>

              <div className="lead-logs-card-container only-mobile">
                <PartialDetailsMobile tableData={modValues.partialDetails} />
              </div>
            </>
          ) : modValues.cardName === "PT_sessions_details" ? (
            <PTTransferDetails
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              prevFilters={filters}
            />
          ) : modValues.cardName === "total_PT_sale" ? (
            <PTSaleDetails
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              onCloseModal={() => setModValues(iniModvalues)}
            />
          ) : null}
        </div>
      </Modal>

      <div className={`createNewCTOModalContainer`}>
        <div className="modalHeadAndCloseContainer mod-with-details">
          <div className="user-info">
            <div className="user-details">
              <span className="mod-header">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33"
                  height="33"
                  viewBox="0 0 33 33"
                  fill="none"
                  onClick={onCloseModal}
                >
                  <g id="navigate_before">
                    <path
                      id="icon"
                      d="M19.25 24.75L11 16.5L19.25 8.25L21.175 10.175L14.85 16.5L21.175 22.825L19.25 24.75Z"
                      fill="#1D1B20"
                    />
                  </g>
                </svg>{" "}
                {rowData?.name || "NA"} (Trainer)
              </span>
              <span className="mod-regular-text underline">
                +91 {rowData?.trainer_mobile || ""}
              </span>
              <span className="mod-regular-text lowercase underline">
                {rowData?.trainer_email || ""}
              </span>
              <span className="mod-light-text">{rowData?.gym_name || ""}</span>
            </div>
          </div>

          <button
            type="button"
            className="closeModalBtn hideMobile"
            onClick={onCloseModal}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-x-lg"
              viewBox="0 0 16 16"
            >
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </button>
        </div>

        <SearchNButtons
          filters={allFilters}
          setFilters={setAllFilters}
          searchFilterApplied={searchFilterApplied}
          onClickSearch={onClickSearch}
        />

        {loading ? null : (
          <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
            {allDatas.allStatsData &&
              Object.entries(allDatas.allStatsData).map(
                ([key, value], index) => {
                  return (
                    <React.Fragment key={index}>
                      <CommonStatCard
                        tagName={key}
                        cardLabel={getCardLabel(key)}
                        value={getCardValue(key, value)}
                      />
                    </React.Fragment>
                  );
                }
              )}
          </div>
        )}

        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <>
            <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile mt30">
              <PaymentLinkTable
                tableData={allDatas.allData}
                tableColumns={tbColumn}
                tablePagination={allDatas.pagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            </div>

            <div className="lead-logs-card-container only-mobile">
              <ApplicableSubsMobile
                tableData={allDatas.allData}
                tablePagination={allDatas.pagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
                setModValues={setModValues}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ApplicableSubscriptions;
